import { ContactInfo } from '@app/core/types/common/contact.types';

export enum ProfileLayoutBlockType {
  Tile = 'tile',
  Contact = 'contact',
  Office = 'office',
}

export enum ProfileLayoutTileType {
  Loyalty = 'loyalty',
  About = 'about',
  Documents = 'documents',
}

export enum ProfileLayoutTileActionType {
  Link = 'link',
}

export type ProfileLayoutTileAction = {
  type: ProfileLayoutTileActionType;
  link: string;
};

export type ProfileLayoutTile = {
  type: string;
  icon: string;
  title: string;
  action: ProfileLayoutTileAction | null;
};

export type ProfileLayoutBlock =
  | { type: ProfileLayoutBlockType.Tile; tile: ProfileLayoutTile }
  | { type: ProfileLayoutBlockType.Contact; contact: ContactInfo }
  | { type: ProfileLayoutBlockType.Office; office: ContactInfo };

export type ProfileLayout = {
  blocks: ProfileLayoutBlock[];
};
